import { onAuthStateChanged } from "firebase/auth";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";

import { getFirebaseAuth } from "services/firebase/auth";

import { MODAL_ROUTES } from "routing/routes";

import useShowConnectMicrosoftAccountModal from "./useShowConnectMicrosoftAccountModal";

export default function useRedirectToConnectMicrosoftAccountModal() {
  const auth = getFirebaseAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const shouldRedirect = useShowConnectMicrosoftAccountModal();

  useEffect(() => {
    const unsubscribeFirebaseEventListener = onAuthStateChanged(auth, () => {
      if (shouldRedirect) {
        navigate(MODAL_ROUTES.CONNECT_MICROSOFT_ACCOUNT.buildPath({}), {
          state: MODAL_ROUTES.CONNECT_MICROSOFT_ACCOUNT.buildState({
            background: location
          })
        });
      }
    });
    return unsubscribeFirebaseEventListener;
  }, [auth, navigate, location, shouldRedirect]);
}
